<div *ngIf="currentJob" class="bmc-jobs-steps">
    <table class="bz-table bz-space--stack-xl">
        <thead>
            <tr>
                <th *ngIf="jobType !== jobTypes.User" class="bz-table__cell bz-table__cell--sortable">
                    <div class="bz-table__col-title">
                        <span class="bz-space--inline-xs">{{ 'JOBS.COLUMN_ID' | translate }}</span>
                    </div>
                </th>
                <th class="bz-table__cell bz-table__cell--sortable">
                    <div class="bz-table__col-title">
                        <span class="bz-space--inline-xs">{{ 'JOBS.COLUMN_NAME' | translate }}</span>
                    </div>
                </th>
                <th class="bz-table__cell bz-table__cell--sortable">
                    <div class="bz-table__col-title">
                        <span class="bz-space--inline-xs">{{ 'JOBS.COLUMN_DESCRIPTION' | translate }}</span>
                    </div>
                </th>
                <th *ngIf="jobType === jobTypes.User" class="bz-table__cell bz-table__cell--sortable">
                    <div class="bz-table__col-title">
                        <span class="bz-space--inline-xs">{{ 'JOBS.COLUMN_CODE' | translate }}</span>
                    </div>
                </th>
            </tr>
        </thead>

        <tbody>
            <tr *ngFor="let step of currentJob.steps">
                <td *ngIf="jobType !== jobTypes.User" class="bz-table__cell">
                    {{ step.idJob }}
                </td>

                <td class="bz-table__cell">
                    <ng-container *ngIf="isDevelopment; else editName">
                        {{ step.jsName || step.name }}
                    </ng-container>
                    <ng-template #editName>
                        <input 
                            [ngModel]="getStepName(step)" 
                            (ngModelChange)="setStepName(step, $event)"
                            class="bmc-jobs-steps__input"
                            [class.valid]="isValidStepName[getOrCreateStepId(step)] === true"
                            [class.invalid]="isValidStepName[getOrCreateStepId(step)] === false" 
                            maxlength="26"
                        />
                    </ng-template>
                </td>

                <td class="bz-table__cell">
                    <ng-container *ngIf="isDevelopment; else editDesc">
                        {{ step.jsDescription || step.description }}
                    </ng-container>
                    <ng-template #editDesc>
                        <input [ngModel]="getStepDescription(step)" (ngModelChange)="setStepDescription(step, $event)"
                            class="bmc-jobs-steps__input">
                    </ng-template>
                </td>

                <td *ngIf="jobType === jobTypes.User" class="bz-table__cell bmc-jobs-steps__table--cell-text">
                    {{ step.jsCode || step.ruleDisplayName }}
                </td>
            </tr>
        </tbody>
    </table>
</div>
<bzg-message  *ngIf="showValidationMessage" [showCloseBtn]="false" [status]="'warning'">
        <span class="bz-space--inline-s "> {{validationMessage | translate}} </span>
    </bzg-message>

<!-- <div *ngIf="!allStepNamesValid && currentJob" class="bmc-jobs-steps__buttons bz-flex bz-flex--end">
    <div class="bmc-jobs-steps__validation-message">
        <bzg-icon [nameIcon]="'icon-warning'" [color]="'warning'" class="bz-space--inline-xs"></bzg-icon>
        {{'JOBS.STEPS_SCHEDULES_NAME_VALIDATION_MESSAGE' | translate}}
    </div>
</div> -->